/** An editor address for 404.html, reserved from public routes and redirects. */
export const NOT_FOUND_PREVIEW_PATH = "/__stackje_missing";
export function isNotFoundPreviewPath(path) {
    try {
        return decodeURIComponent(path).replace(/\/+$/, "") === NOT_FOUND_PREVIEW_PATH;
    }
    catch {
        return false;
    }
}
/** Resolve editing targets without adding the not-found page to the bundle's public routes. */
export function bundlePageFile(routes, path) {
    return path === NOT_FOUND_PREVIEW_PATH ? "404.html" : Object.hasOwn(routes, path) ? routes[path] : undefined;
}
/** Only for compact editor metadata (for example, section order before and after a design change). */
export function bundleEditorRoutes(manifest) {
    return { ...manifest.routes, ...(Object.hasOwn(manifest.files, "404.html") ? { [NOT_FOUND_PREVIEW_PATH]: "404.html" } : {}) };
}
/** Templates and the 404 editor entry aren't routed pages or SEO entries. */
export function isRoutedOwnerPage(page) {
    return !page.template && !page.special;
}
